import React, { type ReactNode, type FC } from 'react';

import { Carousel } from '@/shared/components/Carousel/Carousel';
import { InfoBlockItem } from '@/shared/types/info-block';

import { GalleryCard } from './GalleryCard';
import styles from './ImagesInfoBlock.module.css';

interface ImagesInfoBlockProps {
    subtitle?: string;
    primaryButton?: ReactNode;
    items?: InfoBlockItem[];
}

export const ImagesInfoBlock: FC<ImagesInfoBlockProps> = ({ items, subtitle, primaryButton }) => {
    if (!items?.length) {
        return null;
    }

    return (
        <section className={styles.root}>
            <div className={styles.header}>
                {subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
            </div>

            <Carousel className={styles.carousel}>
                {items.map(({ title, subtitle, backgroundImage, foregroundImage }, index) => (
                    <GalleryCard
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        title={title}
                        subtitle={subtitle}
                        backgroundImage={backgroundImage}
                        foregroundImage={foregroundImage}
                    />
                ))}
            </Carousel>

            <div className={styles.footer}>
                {primaryButton && <div className={styles.buttonsContainer}>{primaryButton}</div>}
            </div>
        </section>
    );
};
